import { useState, useEffect } from "react";
import { ArrowUp } from "@phosphor-icons/react";
import { motion, AnimatePresence } from "framer-motion";

export const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.button
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.8 }}
          onClick={scrollToTop}
          className="fixed bottom-6 right-6 z-50 bg-[#E74C3C] hover:bg-[#C0392B] text-white p-3 rounded-full shadow-lg transition-colors"
          aria-label="Remonter en haut de page"
          data-testid="scroll-to-top-btn"
        >
          <ArrowUp size={24} weight="bold" />
        </motion.button>
      )}
    </AnimatePresence>
  );
};
